import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import queryString from 'query-string';

import { Popup } from 'components/Popup/popup';
import { Dropdown } from 'components/Dropdown/Dropdown';
import Multiselect from 'components/Multiselect';

import ItemLotList from './item-lot-list';
import ItemImport from './item-import';
import ItemEdit from './item-edit';
import ItemAdd from './item-add';

import ItemLotAssign from './item-lot-assign';
import MaintenanceTaskAddSpecific from '../Maintenance/task-specific-add';
import ConfirmationRemove from './confirmation-remove';

import * as ProjectActionType from 'Projects/constants';

import empty_image from 'assets/img/empty-images.svg';

const filterType = [
  { text: 'Inventory', value: 0 },
  { text: 'MFG', value: 1 },
  { text: 'Lot', value: 2 }
];

const CHILD_KEYS = {
  ListItems: 'list-items',
  LotInstalled: 'lot-installed',
  MaintenanceTasks: 'maintenance-tasks',
  AddNewInventoryItems: 'add-new-inventory-items',
  ImportInventory: 'import-inventory',
  EditInventoryItems: 'edit-inventory-items'
};

class InventoryItemList extends Component {
  static propTypes = {
    projectId: PropTypes.string,
    dispatch: PropTypes.func,
    inventoryItemProfile: PropTypes.object,
    inventoryItemList: PropTypes.array,
    history: PropTypes.object,
    location: PropTypes.any,
    request: PropTypes.object,
    onFetchListInventoryItem: PropTypes.func,
    categoryDropdownList: PropTypes.array,
    onGetInventoryProfile: PropTypes.func,
    onRemoveInventoryItem: PropTypes.func,
    onFetchListCategory: PropTypes.func
  }

  constructor(props) {
    super(props);

    this.queryParams = queryString.parse(location.search);
    this.inventoryItemId = this.queryParams.inventoryItemId;

    if (this.inventoryItemId) {
      this.removeQueryParam('inventoryItemId');
    }

    const defaultScreen = (this.inventoryItemId && CHILD_KEYS.EditInventoryItems) || CHILD_KEYS.ListItems;
    this.setState({activeSreen: defaultScreen});

    this.state = {
      activeSreen: defaultScreen,

      currentImportingStep: 0,
      isViewDetail: true,
      searchTxt: '',
      removeInventory: false,
      removeInventoryId: null,
      isCreateMode: false,
      showFilterPopup: false,
      listFilterCategoryId: [],
      categories: [],
      categoryList: [],
      groupByValue: filterType[0],
      isFirstLoad: true,
      disableNext: 'true',
      disableDone: ''
    };

  }

  componentDidMount() {
    this.getCategoryList();
    this.clearFilterAndRefresh();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.categoryDropdownList !== nextProps.categoryDropdownList) {
      const newList = nextProps.categoryDropdownList.map(el => {
        return {
          label: el.name,
          value: el.id
        };
      });
      this.setState({ categoryList: newList },
        () => {
          let queryParams = queryString.parse(location.search);
          if (queryParams.inventoryId && this.state.isFirstLoad === true) {
            this.state.isFirstLoad = false;
            let foundItem = this.state.categoryList.find(x => x.value === queryParams.inventoryId);

            if (foundItem) {
              this.state.categories = [foundItem];
            }

            this.removeQueryParam('inventoryId');
          }
        });
    }
  }

  // user events
  onClickNewButton = () => {
    this.setState({
      searchTxt: '',
      categories: [],
      activeSreen: CHILD_KEYS.AddNewInventoryItems
    });
  }

  onClickOnItem = (id) => {
    this.inventoryItemId = id;
    this.goToEditScreen();
  }

  onClickImportButton = () => {
    this.setState({
      ...this.state,
      searchTxt: '',
      categories: [],
      currentImportingStep: 2,
      activeSreen: CHILD_KEYS.ImportInventory
    });
  }

  onChangeSearchTextbox = (e) => {
    this.setState({ searchTxt: e.target.value });
  }

  onKeyPressSearchTextbox = (e) => {
    if (e.key === 'Enter') {
      this.getInventoryItems();
    }
  }

  onClickSearchButton = () => {
    this.getInventoryItems();
  }

  onLoadCategoryList = () => {
    this.getCategoryList();
  }

  onChangeGroupBy = (e) => {
    this.setState(
      { groupByValue: e.value },
      () => {
        this.props.onFetchListInventoryItem(this.getFilterObject());
      });
  }

  onChangeFilterDropdown = (value) => {
    this.setState({ categories: value });
  }

  onClickFilterIcon = () => {
    this.showFilterPopup();
  }

  onClickRemoveIcon = (id, name) => {
    this.showConfirmRemove(id, name);
  }

  onClickFilterOKButton = () => {
    this.getInventoryItems();
    this.hideFilterPopup();
  }

  onClickDoneImport = () => {
    this.setState({...this.state, disableDone: 'true'}, () => {
      this.importInventoryRef.submit(() => {
        this.setState({...this.state, disableDone: ''}, () => {
          this.goToListThenRefresh();
        });
      });
    });
  }
  // end user event

  // navigators
  goToEditScreen = () => {
    this.setState({
      searchTxt: '',
      categories: [],
      isViewDetail: true,
      activeSreen: CHILD_KEYS.EditInventoryItems
    });
  }

  goToListNoRefresh = () => {
    this.setState({
      activeSreen: CHILD_KEYS.ListItems
    });
  }

  goToListThenRefresh = () => {
    const { projectId, onFetchListInventoryItem } = this.props;
    const { groupByValue } = this.state;
    const queryParams = queryString.parse(location.search);

    this.setState({
      activeSreen: CHILD_KEYS.ListItems
    },
    () => onFetchListInventoryItem({
      projectId: projectId,
      groupOrderType: 0,
      group: groupByValue.value,
      categoryIds: queryParams.inventoryId ? [queryParams.inventoryId] : null
    }));
  }

  goToLotListThenAssignLot = (id) => {
    this.inventoryItemId = id;
    this.setState({
      isCreateMode: true,
      activeSreen: CHILD_KEYS.LotInstalled
    });
  }

  goToLotList = () => {
    this.setState({
      isCreateMode: false,
      activeSreen: CHILD_KEYS.LotInstalled
    });
  }

  goToTaskList = () => {
    this.setState({
      activeSreen: CHILD_KEYS.MaintenanceTasks
    });
  }

  hideItemLotAssign = () => {
    this.setState({ showItemLotAssign: false });
  }

  showFilterPopup = () => {
    if (!this.state.showFilterPopup) {
      document.addEventListener('mousedown', (e) => { this.hideFilterPopup(e); }, false);
      this.setState({ showFilterPopup: true });
    }
  }

  hideFilterPopup = (e) => {
    if (this.state.showFilterPopup) {
      if (e) {
        if (!this.filterPopupRef.contains(e.target)) {
          this.setState({ showFilterPopup: false });
        }
      }
      else {
        this.setState({ showFilterPopup: false });
      }
    }
  }

  showConfirmRemove = (id, name) => {
    this.removedInventoryItem = { id, name };
    // this.removeInventoryId = id;
    // this.removeInventoryItemName = name;

    this.setState({
      removeInventory: true
    });
  }

  hideConfirmRemove = () => {
    this.setState({
      removeInventory: false,
      removeInventoryId: null
    });
  }

  // end navigators

  // services
  removeQueryParam = (...params) => {
    let queryParams = queryString.parse(location.search);

    params.forEach(key => delete queryParams[key]);
    this.props.history.push({
      pathname: location.pathname,
      search: queryString.stringify(queryParams)
    });
  }

  clearFilterAndRefresh() {
    this.setState({
      ...this.state,
      categories: [],
      searchTxt: '',
      groupByValue: filterType[0]
    },
    () => {
      let queryParams = queryString.parse(location.search);

      this.props.onFetchListInventoryItem({
        projectId: this.props.projectId,
        group: this.state.groupByValue.value,
        groupOrderType: 0,
        categoryIds: queryParams.inventoryId ? [queryParams.inventoryId] : null
      });
    });
  }

  getFilterObject = () => {
    return {
      projectId: this.props.projectId,
      group: this.state.groupByValue.value,
      groupOrderType: 0,
      search: this.state.searchTxt,
      categoryIds: this.state.categories.map(x => x.value)
    };
  }

  getInventoryItems = () => {
    this.props.onFetchListInventoryItem(this.getFilterObject());
  }

  getCategoryList = () => {
    this.props.dispatch({
      type: ProjectActionType.GET_LIST_CATEGORY_DROPDOWN_ASYNC,
      params: {
        projectId: this.props.projectId
      }
    });
  }

  removeInventoryItem = (id) => {
    this.props.dispatch({
      type: ProjectActionType.DELETE_INVENTORY_ITEM_ASYNC,
      params: { id: id },
      callback: () => {
        this.setState({ removeInventory: false }, this.getInventoryItems);
      }
    });
  }

  // end services

  // renders
  renderFuncButton = (id, name) => {
    return (
      <i
        className='fa fa-trash cancel-icon func-icon'
        onClick={() => this.onClickRemoveIcon(id, name)}
      />
    );
  };

  renderWizardBar() {
    return (
      <div className='row'>
        <div className='col-md-12 col-xs-12'>
          <button
            className='btn btn-primary btn-siteone'
            disabled={this.state.disableDone}
            onClick={this.onClickDoneImport}
            style={{ float: 'right' }}
          >
            Done
          </button>
        </div>
      </div>
    );
  }

  renderFunctionNav = () => {
    const { searchTxt, groupByValue, categoryList, categories, showFilterPopup } = this.state;

    return (
      <React.Fragment>
        <div className='row'>
          <div style={{ marginBottom: 15 }} className='col-md-12 col-xs-12'>
            <button style={{ float: 'right', marginLeft: 20 }} onClick={this.onClickNewButton} className='btn btn-primary btn-siteone'><span
              className='fa fa-plus icon' /> NEW</button>
            <button style={{ float: 'right' }} onClick={this.onClickImportButton} className='btn btn-default btn-outline'>
              <span className='glyphicon glyphicon-import' /> IMPORT</button>
          </div>
        </div>
        <div className='row'>
          <div className='group-function-inventory-item col-md-9 col-xs-6' style={{ paddingLeft: 0, paddingRight: 0 }}>
            <div className='groupby-inventory-item'>
              <span className='group-by-category-items'>Group by</span>
              <Dropdown
                onChange={this.onChangeGroupBy}
                className='filestring-dropdown filter-dropdown'
                value={groupByValue}
                options={filterType}
                style={{ width: '70%', display: 'table-cell' }}
                optionLabel='text'
                ref={ref => {
                  this.combobox = ref;
                }} />
            </div>

            <div
              className={showFilterPopup ? 'filter-button-category-items-selected' : 'filter-button-category-items'}
              style={{ display: 'table-cell', width: 40, textAlign: 'center' }}
            >
              <button
                id='popup-button'
                className='btn btn-secondary fa fa-filter btn-icon'
                style={{ fontSize: 20, width: 40, height: 20, paddingLeft: 9, borderRadius: '50%', border: 'none' }}
                onClick={this.onClickFilterIcon}
              />
            </div>
            {
              this.state.showFilterPopup &&
              <Popup className='showCategoryFilter-popup' styles={{ width: 400, left: 140, minHeight: 200, top: 10 }} >
                <div className='category-filter-list container-fluid' ref={(ref) => { this.filterPopupRef = ref; }}>
                  <h5>Filters</h5>
                  <label style={{ marginBottom: 5 }} className='title'>Inventory</label>
                  <Multiselect
                    items={categoryList}
                    onChange={this.onChangeFilterDropdown}
                    className='margin-top-5 filestring-dropdown filter-dropdown'
                    value={categories}
                    onRemote={this.onLoadCategoryList}
                    filter={true}
                    placeholder='Any'
                    ref={ref => {
                      this.categoryDropdown = ref;
                    }}
                  />
                  <button
                    onClick={this.onClickFilterOKButton}
                    className='margin-top-10 btn btn-siteone btn-primary'
                  >
                      OK
                  </button>
                </div>
              </Popup>
            }
          </div>

          <div className='col-md-3 col-xs-6'>
            <div className='box-search' style={{ margin: 0, transform: 'translateY(5px)' }}>
              <div className='input-group'>
                <input
                  type='text'
                  id='txt-search-email'
                  ref={ref => { this.search = ref; }}
                  value={searchTxt}
                  className='form-control'
                  placeholder='Search by name'
                  onChange={(this.onChangeSearchTextbox)}
                  onKeyPress={this.onKeyPressSearchTextbox} />
                <span className='input-group-btn'>
                  <button
                    style={{ padding: '4px 10px', fontSize: 16, backgroundColor: '#ececec', border: '0.5px solid #d8d8d8', height: 40 }}
                    onClick={this.onClickSearchButton}
                    className='btn btn-secondary'>
                    <span className='fa fa-search' aria-hidden='true' />
                  </button>
                </span>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>

    );
  }

  renderItemList() {
    let itemList = '';
    const { inventoryItemList, request } = this.props;

    if (this.state.activeSreen === CHILD_KEYS.ListItems) {
      if (isEmpty(inventoryItemList) && !request.search && (!request.filter || !request.filter.categories)) {
        itemList = (
          <div style={{ textAlign: 'center', margin: '5%' }} className='row'>
            <div className='col-md-12 col-xs-12'>
              <img
                src='/images/empty-dashboard_bw.png'
                alt='s1-empty-dashboard'
                style={{ width: 485, opacity: 0.8 }}
              />
            </div>
            <div className='col-md-12 col-xs-12'>
              <h3 style={{ fontSize: 20 }}>No inventory items, yet.</h3>
              <button onClick={this.onClickNewButton} className='category-create-button btn btn-primary btn-siteone'>Create a new inventory item</button>
              <div style={{marginTop: '10px', fontSize: '16px'}}>
                <a href='#' onClick={this.onClickImportButton}>or Import from Library</a>
              </div>
            </div>
          </div>
        );
      }
      else {
        itemList = (
          <div>
            {this.renderFunctionNav()}
            {
              inventoryItemList.map(inventoryList => {
                return (
                  <div key={_.uniqueId()} className='row'>
                    <div className='col-md-12 col-xs-12'>
                      <h4 className='title' style={{ marginTop: 15, marginBottom: 5, fontWeight: 'bold' }}>
                        {inventoryList.group || (this.state.groupByValue.value === 2 ? 'No Lot' : '')}
                      </h4>
                    </div>
                    {
                      inventoryList && inventoryList.items.map(item => {
                        return (
                          <div key={item.id} style={{ marginBottom: 15 }} className='col-xs-4 col-lg-3'>
                            <div className='category-list-items'>
                              <div style={{ marginBottom: 10 }} className='category-list-item-wrapper'>
                                <div className='document-thumbnail-wrapper thumbnail-wrapper-item'>
                                  <img style={{ width: '100%', height: 170, objectFit: 'contain' }} src={item.thumbnail && item.thumbnail.thumbnailUrl ? item.thumbnail.thumbnailUrl : empty_image} />
                                  <div onClick={() => this.onClickOnItem(item.id)} className='document-fade' />
                                  {this.renderFuncButton(item.id, item.name)}
                                </div>
                              </div>
                              <div style={{ display: 'grid', justifyContent: 'left' }} onClick={() => this.onClickOnItem(item.id)} className='category-list-items-project-name'>
                                <div className='category-name col-md-12 col-sm-12'>
                                  <div className='over-flow-text'>{item.name}</div>
                                  <div className='over-flow-text' style={{ color: 'lightgray' }}>Model #{item.model}</div>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                );
              })
            }

            {
              (isEmpty(inventoryItemList) && request.search && request.filter) &&
              <div className='row'>
                <div className='col-md-12 col-xs-12'>
                  <p style={{ marginTop: 25, textAlign: 'center' }}>There are no results</p>
                </div>
              </div>
            }
          </div>
        );
      }
    }
    return itemList;
  }

  render() {
    const { showItemLotAssign, isViewDetail, removeInventory } = this.state;
    const { projectId, history } = this.props;
    const breadcrumbsHistory = history.location.pathname;

    return (
      <div className='manage-inventory-items-container container-fluid'>
        {this.renderItemList()}

        {
          this.state.activeSreen === CHILD_KEYS.AddNewInventoryItems && <ItemAdd
            projectId={projectId}
            breadcrumbsHistory={breadcrumbsHistory}
            onClose={this.goToListThenRefresh}
            onProceedToAssignLot={this.goToLotListThenAssignLot}
          />
        }

        {
          this.state.activeSreen === CHILD_KEYS.EditInventoryItems && <ItemEdit
            projectId={projectId}
            inventoryItemId={this.inventoryItemId}
            onClose={this.goToListThenRefresh}
            breadcrumbsHistory={breadcrumbsHistory}
            isViewDetail={isViewDetail}
            onFetchListInventoryItem={this.props.onFetchListInventoryItem}
            onToggleLotInstalled={this.goToLotList}
            onOpenMaintenanceTasks={this.goToTaskList}
          />
        }

        {
          this.state.activeSreen === CHILD_KEYS.LotInstalled && <ItemLotList
            projectId={projectId}
            inventoryItemId={this.inventoryItemId}
            breadcrumbsHistory={breadcrumbsHistory}
            onClose={this.goToListThenRefresh}
            onBackToEditInventoryItems={this.goToEditScreen}
            isCreateMode={this.state.isCreateMode}
          />
        }

        {
          showItemLotAssign && <ItemLotAssign
            projectId={projectId}
            isOpen={showItemLotAssign}
            onClose={this.hideItemLotAssign}
          />
        }

        {
          removeInventory && <ConfirmationRemove
            item={this.removedInventoryItem}
            onClose={this.hideConfirmRemove}
            onRemove={this.removeInventoryItem} />
        }

        {
          this.state.activeSreen === CHILD_KEYS.ImportInventory && <ItemImport
            projectId={projectId}
            exposeRef={child => { this.importInventoryRef = child; }}
            selectedCategories={[]}
            goBack={this.goToListThenRefresh}
          />
        }

        {
          this.state.activeSreen === CHILD_KEYS.ImportInventory &&
          this.renderWizardBar()
        }

        {
          this.state.activeSreen === CHILD_KEYS.MaintenanceTasks && <MaintenanceTaskAddSpecific
            inventoryItemId={this.inventoryItemId}
            goToList={this.goToListNoRefresh}
            goToEdit={this.goToEditScreen}
          />
        }
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    request: state.ProjectStore.request,
    categoryDropdownList: state.ProjectStore.categoryDropdownList
  };
};

export default withRouter(connect(mapStateToProps)(InventoryItemList));



// WEBPACK FOOTER //
// ./src/Projects/Components/Inventory/item-list.js